var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-scroll-view", { staticClass: "settings-root" }, [
    _c(
      "div",
      { staticClass: "settings-content" },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$ct("title")))]),
        _c(
          "w-card",
          { staticClass: "mb" },
          [
            _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("exact.title")))]),
            _c(
              "w-card-content",
              [
                _c(
                  "w-row",
                  { attrs: { center: "" } },
                  [
                    _c("div", [
                      _vm.exactStatus.Connected
                        ? _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("exact.connected")) + " "
                            ),
                          ])
                        : _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("exact.not-connected")) + " "
                            ),
                          ]),
                      _vm.exactStatus.Connected && _vm.exactStatus.ExpiresAt
                        ? _c("div", { staticClass: "hint" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$ct("exact.expires-at", {
                                    date: _vm.formatExpiry(
                                      _vm.exactStatus.ExpiresAt
                                    ),
                                  })
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("w-spacer"),
                    !_vm.exactStatus.Connected
                      ? _c(
                          "w-button",
                          {
                            attrs: { disabled: _vm.exactBusy },
                            on: {
                              click: function ($event) {
                                return _vm.connectExact()
                              },
                            },
                          },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "link" },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("exact.connect")) + " "
                            ),
                          ],
                          1
                        )
                      : _c(
                          "w-button",
                          {
                            attrs: { disabled: _vm.exactBusy },
                            on: {
                              click: function ($event) {
                                return _vm.disconnectExact()
                              },
                            },
                          },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "unlink" },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("exact.disconnect")) + " "
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "w-card",
          { staticClass: "mb" },
          [
            _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("dossiers.title")))]),
            _c(
              "w-card-content",
              [
                !_vm.dossiers.length
                  ? _c("p", { staticClass: "hint" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("dossiers.none")) + " "),
                    ])
                  : _vm._e(),
                _vm._l(_vm.dossiers, function (d) {
                  return _c(
                    "div",
                    { key: d.DossierID, staticClass: "dossier-item" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "dossier-head",
                          on: {
                            click: function ($event) {
                              return _vm.openDossier(d)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "dossier-name" }, [
                            _vm._v(_vm._s(d.DossierName)),
                          ]),
                          _c("span", { staticClass: "dossier-client" }, [
                            _vm._v(_vm._s(d.CompanyName)),
                          ]),
                          _c("w-spacer"),
                          _c(
                            "span",
                            {
                              staticClass: "badge",
                              class: `badge-${d.IntegrationType}`,
                            },
                            [_vm._v(_vm._s(_vm.integrationLabel(d)))]
                          ),
                          _c("w-fa", {
                            staticClass: "chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "w-card",
          [
            _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("clearfacts.title")))]),
            _c(
              "w-card-content",
              [
                _c(
                  "w-row",
                  { attrs: { center: "" } },
                  [
                    _c("div", [
                      _vm.clearfactsStatus.Connected
                        ? _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.clearfactsStatus.Email
                                    ? _vm.$ct("clearfacts.connected-as", {
                                        user: _vm.clearfactsStatus.Email,
                                      })
                                    : _vm.$ct("clearfacts.connected")
                                ) +
                                " "
                            ),
                          ])
                        : _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("clearfacts.not-connected")) +
                                " "
                            ),
                          ]),
                      _vm.clearfactsStatus.Connected &&
                      _vm.clearfactsStatus.ExpiresAt
                        ? _c("div", { staticClass: "hint" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$ct("clearfacts.expires-at", {
                                    date: _vm.formatExpiry(
                                      _vm.clearfactsStatus.ExpiresAt
                                    ),
                                  })
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("w-spacer"),
                    !_vm.clearfactsStatus.Connected
                      ? _c(
                          "w-button",
                          {
                            attrs: { disabled: _vm.clearfactsBusy },
                            on: {
                              click: function ($event) {
                                return _vm.connectClearfacts()
                              },
                            },
                          },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "link" },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("clearfacts.connect")) + " "
                            ),
                          ],
                          1
                        )
                      : _c(
                          "w-button",
                          {
                            attrs: { disabled: _vm.clearfactsBusy },
                            on: {
                              click: function ($event) {
                                return _vm.disconnectClearfacts()
                              },
                            },
                          },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "unlink" },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("clearfacts.disconnect")) +
                                " "
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                !_vm.clearfactsStatus.Connected
                  ? [
                      _c("w-input", {
                        staticClass: "mts",
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("clearfacts.domain"),
                        },
                        model: {
                          value: _vm.clearfactsDomain,
                          callback: function ($$v) {
                            _vm.clearfactsDomain = $$v
                          },
                          expression: "clearfactsDomain",
                        },
                      }),
                      _c("div", { staticClass: "hint" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("clearfacts.domain-hint")) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "hint mts" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$ct("clearfacts.token-alternative")) +
                            " "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }